import authAPI from "../../api/auth";

const state = {
  ready: false,

  user: null,

  authenticationStatus: false,

  verificationStatus: false,
};

const getters = {
  isAuthenticated: (state) => {
    return state.ready && state.authenticationStatus && state.user && state.user._id;
  },
  userID: (state) => {
    return state.user && state.user._id ? state.user._id : null;
  },
};

const mutations = {
  ready(state, isReady) {
    state.ready = isReady;
  },
  updateAuthenticationStatus(state, newStatus) {
    state.authenticationStatus = newStatus;
  },
  updateVerificationStatus(state, newStatus) {
    state.verificationStatus = newStatus;
  },

  setUserVerified(state) {
    if (state.user) {
      state.user.verificationStatus = true;
    }
  },
  updateUser(state, newUser) {
    state.user = newUser;
    state.userId = newUser ? newUser._id : "";
  },
  updateAll(state, data) {
    state.authenticationStatus = data.authenticationStatus;
    state.verificationStatus = data.verificationStatus;
    state.user = data.user;
    state.userId = data.userId;
    state.ready = true;
  },

  setUserDisplayName(state, name) {
    if (state.user) {
      state.user.displayName = name;
    }
  },

  setUserProfileImage(state, url) {
    if (state.user) {
      state.user.profileImageUrl = url;
    }
  },

  updateUserNotificationPreferences(state, updateData) {
    if (state.user) {
      state.user.notificationPreferences[updateData.type][updateData.field] = updateData.newValue;
    }
  },

  updateUserEmailPreferences(state, updateData) {
    if (state.user) {
      state.user.emailPreferences[updateData.type] = updateData.newValue;
    }
  },
};

const actions = {
  authenticate: async ({ commit }) => {
    const response = await authAPI.authenticate();
    if (response && response.data && response.data.success) {
      commit("updateAuthenticationStatus", true);
      commit("updateVerificationStatus", response.data.verificationStatus);
      commit("updateUser", response.data.user);
      commit("ready", true);
    } else {
      commit("updateAuthenticationStatus", false);
      commit("updateUser", null);
      commit("ready", true);
    }

    return true;
  },

  updateVerificationStatus(state, newStatus) {
    state.commit("updateVerificationStatus", newStatus);
  },

  setUserVerified(state) {
    state.commit("setUserVerified");
  },

  setUserDisplayName(state, name) {
    state.commit("setUserDisplayName", name);
  },

  setUserProfileImage(state, url) {
    state.commit("setUserProfileImage", url);
  },
  updateUserNotificationPreferences(state, updateData) {
    state.commit("updateUserNotificationPreferences", updateData);
  },
  updateUserEmailPreferences(state, updateData) {
    state.commit("updateUserEmailPreferences", updateData);
  },
};

const auth = {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
};

export default auth;
